import Checkbox from '@material-ui/core/Checkbox';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { useCallback, useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { IEmpresas } from '../../interfaces/IEmpresas';
import { IAgrupadoPorConta, IRelatorio } from '../../interfaces/IRelatorio';
import RelatoriosService from '../../services/RelatoriosService';
import { Formatter, Tipo } from './Relatorio';

/*Tradução */
import '../../../i18n/config';
import { useTranslation } from 'react-i18next';

interface ILinhaCabecalho {
  id: string,
  nome: string
}

const nomesCabecalho: ILinhaCabecalho[] = [
  { id: '0', nome: 'Conta Ref.' },
  { id: '1', nome: 'Descrição Referencial' },
  { id: '2', nome: 'Conta Empresa' },
  { id: '3', nome: 'Descrição Empresa' },
  { id: '4', nome: 'Saldo Inicial' },
  { id: '5', nome: 'Lançamento' },
  { id: '6', nome: 'Movimentação Débito' },
  { id: '7', nome: 'Movimentação Crédito' },
  { id: '8', nome: 'Saldo Final' },
  { id: '9', nome: 'Lançamento' },
  { id: '10', nome: 'Porcentagem Conciliação' },
  { id: '11', nome: 'Imprimir' }
];

function Row({ styles, empresa, dataInicial, dataFinal, relatorio, trocarValor, funcaoSelecionado }: { styles: any, empresa: IEmpresas | undefined, dataInicial: Date | undefined, dataFinal: Date | undefined, relatorio: IRelatorio, trocarValor: (contaEmpresa: string, marcado: boolean) => void, funcaoSelecionado: (contaEmpresa: string) => boolean }) {
  const [open, setOpen] = useState<boolean>(false);
  const [agrupadoPorConta, setAgrupadoPorConta] = useState<IAgrupadoPorConta>({} as IAgrupadoPorConta);
  const history = useHistory();
  const [loadingReport, setLoadingReport] = useState<boolean>(false);
  async function funcaoClicar() {
    setOpen(!open);

    if (!open && empresa?.id !== undefined && empresa?.id >= 0 && dataInicial && dataFinal) {
      localStorage.setItem(`${Tipo.AbaSelecionada}`, "3");
      await RelatoriosService.agrupadoPorConta(empresa.id, dataInicial, dataFinal, relatorio.contaEmpresa, x => setAgrupadoPorConta(x));
    }
  }

  return <>
    <TableRow style={{ outline: '1px solid #A3A3A3', backgroundColor: relatorio.status === 'Concluida' ? 'rgba(0, 183, 161, 0.1)' : 'unset' }} >
      <TableCell className={styles.cell} align='center'>
        <IconButton aria-label="expand row" size="small" onClick={funcaoClicar}>
          {
            open ?
              <i className="bi bi-arrow-up" style={{ color: '#525252' }} />
              :
              <i className="bi bi-arrow-down" style={{ color: '#525252' }} />
          }
        </IconButton>
        {relatorio.contaReferencial}
      </TableCell>
      <TableCell className={styles.cell} align='left'>{relatorio.descricaoReferencial}</TableCell>
      <TableCell className={styles.cell} align='center'>{relatorio.contaEmpresa}</TableCell>
      <TableCell className={styles.cell} align='left'>{relatorio.descricaoEmpresa}</TableCell>
      <TableCell className={styles.cell} align='center'>{Formatter.format(relatorio.saldoInicial)}</TableCell>
      <TableCell className={styles.cell} align='center'>{relatorio.lancamentoInicial}</TableCell>
      <TableCell className={styles.cell} align='left' style={{ paddingLeft: '25px' }}>{Formatter.format(relatorio.debito)}</TableCell>
      <TableCell className={styles.cell} align='left'>{Formatter.format(relatorio.credito)}</TableCell>
      <TableCell className={styles.cell} align='center'>{Formatter.format(relatorio.saldoFinalReal)}</TableCell>
      <TableCell className={styles.cell} align='center'>{relatorio.lancamento}</TableCell>
      <TableCell className={styles.cell} align='center'>{relatorio.porcentagemConciliado}</TableCell>
      <TableCell>
        {loadingReport ? (
          <span className='indicator-progress' style={{ display: 'block' }}>
            <span className='spinner-border spinner-border-sm' style={{ marginRight: '5px' }} />
          </span>
        ) : <i onClick={(e) => {
          setLoadingReport(true);
          e.stopPropagation();
          RelatoriosService.pegarUrlImpressaoNovo(empresa?.id || 0, [[{
            conta: relatorio?.contaEmpresa || '',
            id: relatorio?.id || 0
          }]], true, dataInicial || new Date(), dataFinal || new Date(), (x) => {
            window.open(URL.createObjectURL(x), '_blank');
            setLoadingReport(false);
          }).catch(() => {
            setLoadingReport(false);
          });
        }} className='fa fa-eye fs-4 mt-2' style={{ color: 'gray' }} />}
      </TableCell>
      <TableCell className={styles.cell} align='center'>
        <Checkbox onChange={e => trocarValor(relatorio.contaEmpresa, e.target.checked)} checked={funcaoSelecionado(relatorio.contaEmpresa)} />
      </TableCell>
      {relatorio.possuiAvisosOuErros && (
        <TableCell className={styles.cell} align='center'>
          <i className="bi bi-info-circle" style={{ color: '#525252' }} />
        </TableCell>
      )}
    </TableRow>
    <TableRow style={{ transform: 'translate(10px, 0)' }} >
      <TableCell style={{ border: 'none', padding: '0' }} colSpan={11}>
        <Collapse in={open} style={{ backgroundColor: '#EFF0F5', margin: '0.5px 0 1px 0', width: 'calc(100% - 20px)' }} >
          <Table>
            <TableHead>
              {
                <TableRow style={{ outline: '1px solid #A3A3A3', border: 'none' }}>
                  <TableCell style={{ border: 'none' }}>
                    <div style={{ border: 'none', display: 'flex' }}>
                      <i onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Erro}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Erro}`); }} className="fas fa-exclamation-circle" style={{ padding: '3px 5px 0 0', color: '#EB1F44', cursor: 'pointer' }} />
                      <label onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Erro}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Erro}`); }} style={{ cursor: 'pointer' }}>Erros: {agrupadoPorConta.erros}</label>
                    </div>
                  </TableCell>
                  <TableCell style={{ border: 'none' }}>
                    <div style={{ border: 'none', display: 'flex' }}>
                      <i onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Aviso}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Aviso}`); }} className="fas fa-exclamation-triangle" style={{ padding: '3px 5px 0 0', color: '#FFB629', cursor: 'pointer' }} />
                      <label onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Aviso}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Aviso}`); }} style={{ cursor: 'pointer' }}>Avisos: {agrupadoPorConta.avisos}</label>
                    </div>
                  </TableCell>
                  <TableCell style={{ border: 'none' }}>
                    <div style={{ border: 'none', display: 'flex' }}>
                      <i onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Recomendacao}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Recomendacao}`); }} className="fas fa-exclamation-circle" style={{ padding: '3px 5px 0 0', color: '#0FC1C1', cursor: 'pointer' }} />
                      <label onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Recomendacao}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Recomendacao}`); }} style={{ cursor: 'pointer' }}>Recomendações: {agrupadoPorConta.recomendacoes}</label>
                    </div>
                  </TableCell>
                  <TableCell style={{ border: 'none' }}>
                    <div style={{ border: 'none', display: 'flex' }}>
                      <i onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Match}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Match}`); }} className="fas fa-compress-alt" style={{ padding: '3px 5px 0 0', color: '#00B757', cursor: 'pointer' }} />
                      <label onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Match}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Match}`); }} style={{ cursor: 'pointer' }}>Match de Conciliaçõe: {agrupadoPorConta.matchesConciliacao}</label>
                    </div>
                  </TableCell>
                  <TableCell style={{ border: 'none' }}>
                    <div style={{ border: 'none', display: 'flex' }}>
                      <i onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Pendente}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Pendente}`); }} className="fas fa-external-link-alt" style={{ padding: '3px 5px 0 0', color: '#FF9029', cursor: 'pointer' }} />
                      <label onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Pendente}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Pendente}`); }} style={{ cursor: 'pointer' }}>Pendentes de Conciliações: {agrupadoPorConta.pendentesConciliacao}</label>
                    </div>
                  </TableCell>
                  <TableCell style={{ border: 'none' }}>
                    <div style={{ border: 'none', display: 'flex' }}>
                      <i onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Conciliado}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Conciliado}`); }} className="fas fa-compress-arrows-alt" style={{ padding: '3px 5px 0 0', color: '#FF9029', cursor: 'pointer' }} />
                      <label onClick={() => { localStorage.setItem(`${Tipo.ContaEmpresa}`, relatorio.contaEmpresa); localStorage.setItem(`${Tipo.Conciliado}`, `${relatorio.contaEmpresa} - ${relatorio.descricaoReferencial}`); history.push(`${empresa?.id}/${Tipo.Conciliado}`); }} style={{ cursor: 'pointer' }}>Conciliados: {agrupadoPorConta.conciliados}</label>
                    </div>
                  </TableCell>
                </TableRow>
              }
            </TableHead>
          </Table>
        </Collapse>
      </TableCell>
    </TableRow>
  </>
}

function RelatorioRelatorio({ empresa, dataInicial, dataFinal, setDadosExportar }: { empresa: IEmpresas | undefined, dataInicial: Date | undefined, dataFinal: Date | undefined, setDadosExportar: any }) {
  const [carregado, setCarregado] = useState<boolean>(false);
  const [dadosResumidos, setDadosResumidos] = useState<IRelatorio[]>([]);
  const [selecionados, setSelecionados] = useState<string[]>([]);
  const [todosMarcados, setTodosMarcados] = useState<boolean>(false);
  const [filtro, setFiltro] = useState<string>('');
  const [numeroStatusFiltro, setNumeroStatusFiltro] = useState<number>(0);
  const [numeroGrupoFiltro, setNumeroGrupoFiltro] = useState<number>(0);
  const { t } = useTranslation();
  const useStyles = makeStyles({
    cell: {
      padding: '4px'
    }
  });
  const styles = useStyles();

  useEffect(() => {
    async function preCarregar(offset: number) {
      setCarregado(false);
      if (empresa?.id !== undefined && empresa?.id >= 0 && dataInicial && dataFinal && new Date(dataInicial).toISOString().split('-')[0] === new Date(dataFinal).toISOString().split('-')[0]) {
        await RelatoriosService.dadosResumidos(empresa.id, dataInicial, dataFinal, offset, x => {
          setDadosResumidos((old) => {
            const newArray = [...old];
            return newArray.concat(x);
          });

          if (x && x.length > 0) {
            preCarregar(offset + x.length);
          }
        });

        setCarregado(true);
      }
    }

    setTimeout(() => {
      preCarregar(0);
    }, 1000)

  }, [empresa, dataInicial, dataFinal]);

  useEffect(() => {
    setTodosMarcados(dadosResumidos.length > 0 && selecionados.length === dadosResumidos.length);
    localStorage.setItem(`${Tipo.ListaContasEmpresa}`, JSON.stringify(selecionados));

    //eslint-disable-next-line
  }, [selecionados]);

  const trocarTodosValores = useCallback(async (valor: boolean) => {
    if (valor) {
      const listaContasEmpresa = dadosResumidos.map(x => x.contaEmpresa);
      setSelecionados(listaContasEmpresa);
      localStorage.setItem(`${Tipo.ListaContasEmpresa}`, JSON.stringify(listaContasEmpresa));

      setDadosExportar(() => {
        return dadosResumidos.map(d => ({
          'Conta Referencial': d.contaReferencial,
          'Descrição Referencial': d.descricaoReferencial,
          'Conta Empresa': d.contaEmpresa,
          'Descrição Empresa': d.descricaoEmpresa,
          'Saldo Inicial': d.saldoInicial,
          'Lançamento': d.lancamentoInicial,
          'Débito': d.debito,
          'Crédito': d.credito,
          'Saldo Final': d.saldoFinalReal,
          'Lançamento Final': d.lancamento
        }));
      });
    }
    else {
      setDadosExportar([]);
      setSelecionados([]);
    }
  }, [dadosResumidos, setDadosExportar]);

  const getStatusByValue = useCallback((value: number) => {
    switch (value) {
      case 0:
        return null;
      case 1:
        return 'Arquivado';
      case 2:
        return 'Pendentes';
      case 3:
        return 'Em processamento';
      case 4:
        return 'Conciliado Parcial';
      case 5:
        return 'Conciliacao';
      case 6:
        return 'Em Conferencia';
      case 7:
        return 'Concluida';
      default:
        return null;
        break;
    }
  }, []);

  const classifyByGroup = useCallback((item: IRelatorio, groupNumberSelected: number) => {
    switch (groupNumberSelected) {
      case 0:
        return item;
      case 1:
        return item.isTributo ? item : null;
      case 2:
        return item.isBanco ? item : null;
      case 3:
        return item.isImobilizado ? item : null;
      case 4:
        return item.isDepreciado ? item : null;
      case 5:
        return item.isEstoque ? item : null;
      case 6:
        return item.isSalario ? item : null;
      case 7:
        return item.isFornecedor ? item : null;
      case 8:
        return item.isFolhaPagamento ? item : null;
      case 9:
        return item.isCapitalSocial ? item : null;
      case 10:
        return item.isLucrosAcumulados ? item : null;
      case 11:
        return item.isPrejuizosAcumulados ? item : null;
      case 12:
        return item.isCapitalSubscrever ? item : null;
      case 13:
        return item.isEmprestimo ? item : null;
      case 14:
        return item.isInvestimento ? item : null;
      case 15:
        return item.isAdiantamento ? item : null;
      case 16:
        return item.isDiferido ? item : null;
      case 17:
        return item.isAjusteValorJusto ? item : null;
      case 18:
        return item.isDesagio ? item : null;
      case 19:
        return item.isDistribuicaoLucro ? item : null;
      case 20:
        return item.isMutuo ? item : null;
      case 21:
        return item.isRetido ? item : null;
      case 22:
        return item.isVendedorMercadoria ? item : null;
      case 23:
        return item.isParcelamentoTributo ? item : null;
      default:
        return null;
        break;
    }
  }, []);


  const trocarValor = useCallback(async (contaEmpresa: string, valor: boolean) => {
    if (valor) {
      setSelecionados((old) => {
        const copy = old || [];
        copy.push(contaEmpresa);

        setDadosExportar(() => {
          return dadosResumidos.filter(x => copy.includes(x.contaEmpresa)).map(d => ({
            'Conta Referencial': d.contaReferencial,
            'Descrição Referencial': d.descricaoReferencial,
            'Conta Empresa': d.contaEmpresa,
            'Descrição Empresa': d.descricaoEmpresa,
            'Saldo Inicial': d.saldoInicial,
            'Lançamento': d.lancamento,
            'Débito': d.debito,
            'Crédito': d.credito,
            'Saldo': d.saldoFinalReal
          }));
        });

        localStorage.setItem(`${Tipo.ListaContasEmpresa}`, JSON.stringify(copy));

        return copy;
      });
    }
    else {
      setSelecionados((old) => {
        const copy = old || [];
        const result = copy.filter(x => x !== contaEmpresa);

        setDadosExportar(() => {
          return dadosResumidos.filter(x => result.includes(x.contaEmpresa)).map(d => ({
            'Conta Referencial': d.contaReferencial,
            'Descrição Referencial': d.descricaoReferencial,
            'Conta Empresa': d.contaEmpresa,
            'Descrição Empresa': d.descricaoEmpresa,
            'Saldo Inicial': d.saldoInicial,
            'Lançamento': d.lancamento,
            'Débito': d.debito,
            'Crédito': d.credito,
            'Saldo': d.saldoFinalReal
          }));
        });

        localStorage.setItem(`${Tipo.ListaContasEmpresa}`, JSON.stringify(result));
        return result;
      });
    }
  }, [dadosResumidos, setDadosExportar]);

  const getDadosComFiltro = useCallback(() => {

    return dadosResumidos.filter((i) => {
      let obj: IRelatorio | null = i;

      if (filtro) {
        const value = `${i.contaEmpresa} - ${i.contaReferencial} - ${i.descricaoEmpresa} - ${i.descricaoReferencial}`.toLowerCase();
        if (value.includes(filtro.toLowerCase())) {
          obj = i;
        }
        else {
          obj = null;
        }
      }

      const getFiltroStatus = getStatusByValue(numeroStatusFiltro);

      if (getFiltroStatus) {
        if (obj && obj.status === getFiltroStatus) {
          obj = i;
        } else {
          obj = null;
        }
      }

      if (obj) {
        obj = classifyByGroup(i, numeroGrupoFiltro);
      }

      return obj;
    });
  }, [dadosResumidos, filtro, numeroStatusFiltro, numeroGrupoFiltro]);

  return <>
    {

      dataInicial && dataFinal ?
        new Date(dataInicial).toISOString().split('-')[0] === new Date(dataFinal).toISOString().split('-')[0] ?
          carregado ?
            dadosResumidos.length > 0 ?
              <div className="row">
                <div className='col-md-12 mt-4'>
                  <div className='row'>
                    <div className='col-md-4 form-group'>
                      <label>{t("Selecione um status")}</label>
                      <select className='form-control' value={numeroStatusFiltro} onChange={(e) => { setNumeroStatusFiltro(parseInt(e.target.value)) }}>
                        <option value={0}>{t("Todos")}</option>
                        <option value={1}>{t("Rascunho")}</option>
                        <option value={2}>{t("Pendentes")}</option>
                        <option value={3}>{t("Conciliação Automática")}</option>
                        <option value={4}>{t("Conciliado Parcial")}</option>
                        <option value={5}>{t("Conciliação Inteligente")}</option>
                        <option value={6}>{t("Em Conferência")}</option>
                        <option value={7}>{t("Concluído")}</option>
                      </select>
                    </div>
                    <div className='col-md-4 form-group'>
                      <label>{t("Selecione um grupo")}</label>
                      <select className='form-control' value={numeroGrupoFiltro} onChange={(e) => { setNumeroGrupoFiltro(parseInt(e.target.value)) }}>
                        <option value={0}>{t("Todos")}</option>
                        <option value={1}>{t("Tributo")}</option>
                        <option value={2}>{t("Banco/Caixa")}</option>
                        <option value={3}>{t("Imobilizado")}</option>
                        <option value={4}>{t("Depreciado")}</option>
                        <option value={5}>{t("Estoque")}</option>
                        <option value={6}>{t("Salário")}</option>
                        <option value={7}>{t("Cliente/Fornecedor")}</option>
                        <option value={8}>{t("Folha de Pagamento")}</option>
                        <option value={9}>{t("Capital Social")}</option>
                        <option value={10}>{t("Lucros Acumulados")}</option>
                        <option value={11}>{t("Prejuízos Acumulados")}</option>
                        <option value={12}>{t("Capital a Subscrever")}</option>
                        <option value={13}>{t("Empréstimo")}</option>
                        <option value={14}>{t("Investimento")}</option>
                        <option value={15}>{t("Adiantamento")}</option>
                        <option value={16}>{t("Diferido")}</option>
                        <option value={17}>{t("Ajuste Valor Justo")}</option>
                        <option value={18}>{t("Deságio")}</option>
                        <option value={19}>{t("Distribuição de Lucro")}</option>
                        <option value={20}>{t("Mútuo")}</option>
                        <option value={21}>{t("Retido")}</option>
                        <option value={22}>{t("Venda de Mercadoria")}</option>
                        <option value={23}>{t("Parcelamento Tributo")}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 form-group mt-4">
                  <input className="form-control" placeholder={t("Filtrar por Descrição referencial, Conta empresa, Conta referencial e Descrição empresa...")} onChange={(e) => setFiltro(e.target.value)} />
                </div>
                <div className="col-md-12">
                  <Table aria-label="collapsible table" style={{ userSelect: 'none', marginBottom: '200px' }}>
                    <TableHead>
                      <TableRow hover role="checkbox" style={{ border: 'none', outline: '1px solid #A3A3A3' }} >
                        {
                          nomesCabecalho.map((x, index) => <TableCell key={index} className={styles.cell} align={index === 0 ? 'center' : 'left'} style={{ fontWeight: 600, color: '#5E6397', textAlign: 'center' }}>{t(x.nome)}</TableCell>)
                        }
                        <TableCell padding="checkbox" className={styles.cell} align='center'>
                          <Checkbox onChange={e => trocarTodosValores(e.target.checked)} checked={todosMarcados} />
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {
                        getDadosComFiltro().map((x, index) => <Row key={index} styles={styles} empresa={empresa} dataInicial={dataInicial} dataFinal={dataFinal} relatorio={x} trocarValor={trocarValor} funcaoSelecionado={(contaEmpresa: string) => selecionados.find(x => x === contaEmpresa) !== undefined} />)
                      }
                    </TableBody>
                  </Table>
                </div>
              </div>
              : <h2 className="mt-5">{t("Não há dados para serem exibidos")}</h2>
            : <p className="mt-5">{t("Carregando...")}</p>
          : <h2 className="mt-5">{t("As datas de início e fim devem estar contidas dentro do mesmo ano.")}</h2>
        : <h2 className="mt-5">{t("Preencha o campo Período e clique em buscar para carregar os dados")}</h2>
    }
  </>
}

export default RelatorioRelatorio;